import {Injectable} from "@angular/core";
import {Http, ResponseContentType} from "@angular/http";
import {Observable} from "rxjs/Observable";


@Injectable()
export class NeocheckService {

    constructor(private _http: Http) {
    }

    getUrlPlugin(lang): Observable<any> {
        return this._http.get('/api/client/private/getPluginUrl?language='+lang).map(response => response.json())
    }

    getResult(neocheckToken): Observable<any> {
        return this._http.get('/api/client/private/getResult/?token=' + neocheckToken).map(response => response.text());
    }

    checkAddress(obj, attachments): Observable<any> {

        let body = {
          streetName: obj.address,
          city: obj.city,
          country: obj.country,
          state: obj.countyOrRegion,
          postalCode: obj.zipCode,
          documentImagesBase64: attachments
        }
        return this._http.post('api/client/private/check_address', body);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/neocheck.service.ts